import { render } from "./PortfolioNorthlink.vue?vue&type=template&id=1a5dec90"
import script from "./PortfolioNorthlink.vue?vue&type=script&lang=js"
export * from "./PortfolioNorthlink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__